// Configuración única de navegación para mantener estilo y rutas consistentes
import {
    LayoutDashboard,
    Users,
    Calendar,
    Utensils,
    Upload,
    ClipboardList,
    MapPin,
    Building2,
    Receipt,
    Settings,
} from 'lucide-react';

export const NAV_SUPERADMIN = [
    {
        group: 'OPERACIONES',
        items: [
            { label: 'Dashboard', icon: LayoutDashboard, to: '/admin/dashpage', color: 'text-blue-400' },
            { label: 'Pedidos', icon: Receipt, to: '/admin/AbmPedidos', color: 'text-fuchsia-400' },
        ]
    },
    {
        group: 'MENÚ',
        items: [
            { label: 'Platos', icon: Utensils, to: '/admin/AbmPlatos', color: 'text-orange-400' },
            { label: 'Tipos de Menú', icon: Settings, to: '/admin/AbmTiposMenu', color: 'text-indigo-400' },
            { label: 'Cargar Menú', icon: Upload, to: '/admin/CargarMenuSemanal', color: 'text-orange-400' },
            { label: 'Configuración Semanal', icon: Settings, to: '/admin/configuracion-semanal', color: 'text-slate-400' },
        ]
    },
    {
        group: 'UBICACIÓN',
        items: [
            { label: 'Sedes', icon: Building2, to: '/admin/AbmSedes', color: 'text-blue-400' },
            { label: 'Sectores', icon: Building2, to: '/admin/AbmSectores', color: 'text-orange-400' },
            { label: 'Direcciones', icon: MapPin, to: '/admin/AbmDirecciones', color: 'text-emerald-400' },
        ]
    },
    {
        group: 'ADMINISTRACIÓN',
        items: [
            { label: 'Usuarios', icon: Users, to: '/admin/AbmUsuarios', color: 'text-indigo-400' },
        ]
    },
    {
        group: 'MI ÁREA',
        items: [
            { label: 'Mi Pedido Semanal', icon: ClipboardList, to: '/admin/mipedidosemanal', color: 'text-amber-400' },
            { label: 'Selección', icon: Calendar, to: '/admin/seleccion', color: 'text-emerald-400' },
        ]
    }
];

export const NAV_ADMIN = [
    {
        group: 'OPERACIONES',
        items: [
            { label: 'Dashboard', icon: LayoutDashboard, to: '/admin/dashpage', color: 'text-blue-400' },
            { label: 'Pedidos', icon: Receipt, to: '/admin/AbmPedidos', color: 'text-fuchsia-400' },
        ]
    },
    {
        group: 'MENÚ',
        items: [
            { label: 'Platos', icon: Utensils, to: '/admin/AbmPlatos', color: 'text-orange-400' },
            { label: 'Cargar Menú', icon: Upload, to: '/admin/CargarMenuSemanal', color: 'text-orange-400' },
        ]
    },
    {
        group: 'UBICACIÓN',
        items: [
            { label: 'Sedes', icon: Building2, to: '/admin/AbmSedes', color: 'text-blue-400' },
            { label: 'Sectores', icon: Building2, to: '/admin/AbmSectores', color: 'text-orange-400' },
            { label: 'Direcciones', icon: MapPin, to: '/admin/AbmDirecciones', color: 'text-emerald-400' },
        ]
    },
    {
        group: 'ADMINISTRACIÓN',
        items: [
            { label: 'Usuarios', icon: Users, to: '/admin/AbmUsuarios', color: 'text-indigo-400' },
        ]
    },
    {
        group: 'MI ÁREA',
        items: [
            { label: 'Mi Pedido Semanal', icon: ClipboardList, to: '/admin/mipedidosemanal', color: 'text-amber-400' },
            { label: 'Selección', icon: Calendar, to: '/admin/seleccion', color: 'text-emerald-400' },
        ]
    }
];

export const NAV_USER = [
    {
        group: 'PERSONAL',
        items: [
            { label: 'Mi Pedido Semanal', icon: ClipboardList, to: '/user/mipedidosemanal' },
            { label: 'Selección', icon: Calendar, to: '/user/seleccion' },
        ]
    }
];
